import React from "react";
import classNames from "classnames";

import { showMiniBoxMessage, hideMiniBoxMessage } from "./lib/actions";
import miniMessageBoxReducer from "./lib/reducers";

interface Props {
  show: boolean;
  message: string;
  type: string;
}

const MiniMessageBoxContainer: React.FC<Props> = ({ show, type, message }: Props): JSX.Element => {
  const MiniMessageBoxClasses = classNames("message-box-wrapper mini", type, { show: show });

  return (
    <div className={MiniMessageBoxClasses}>
      <div className="mini-message-content">{message}</div>
    </div>
  );
};

export { MiniMessageBoxContainer, showMiniBoxMessage, hideMiniBoxMessage, miniMessageBoxReducer };
